import { UISchema } from '@/type';
import { MaterialEditorConfig } from '../type';
import { getBasicMaterialSchema } from './basic-material-schema';
import { getStandardMaterialSchema } from './standard-material-schema';
import { getPhysicalMaterialSchema } from './physical-material-schema';
import { getLineMaterialSchema } from './line-material-schema';

export function getMaterialSchema(config: MaterialEditorConfig): UISchema {
  const { type } = config;
  if (type === 'MeshBasicMaterial') {
    return getBasicMaterialSchema(config);
  } else if (type === 'MeshStandardMaterial') {
    return getStandardMaterialSchema(config);
  } else if (type === 'MeshPhysicalMaterial') {
    return getPhysicalMaterialSchema(config);
  } else if (type === 'LineMaterial') {
    return getLineMaterialSchema(config);
  }
  return [];
}

export function getMaterialUVSchema(): UISchema {
  return [
    {
      uiType: 'InputSlider',
      label: '旋转',
      fieldName: 'uvRotation',
      min: 0,
      max: 360,
    },
    {
      uiType: 'InputSlider',
      label: 'X轴缩放',
      fieldName: 'uvRepeatScale.x',
      min: 0,
      max: 10,
    },
    {
      uiType: 'InputSlider',
      label: 'Y轴缩放',
      fieldName: 'uvRepeatScale.y',
      min: 0,
      max: 10,
    },
    {
      uiType: 'InputSlider',
      label: 'X轴偏移',
      fieldName: 'uvOffset.x',
      min: 0,
      max: 10,
      precisionOnSave: 4,
      precisionOnShow: 4,
    },
    {
      uiType: 'InputSlider',
      label: 'Y轴偏移',
      fieldName: 'uvOffset.y',
      min: 0,
      max: 10,
      precisionOnSave: 4,
      precisionOnShow: 4,
    },
    {
      uiType: 'InputSlider',
      label: 'X轴速度',
      fieldName: 'uvOffsetSpeed.x',
      min: -2,
      max: 2,
    },
    {
      uiType: 'InputSlider',
      label: 'Y轴速度',
      fieldName: 'uvOffsetSpeed.y',
      min: -2,
      max: 2,
    },
  ];
}

export function getTextureUVSchema(): UISchema {
  const wrapModeOptions = [
    {
      key: 1000, // repeat
      label: '重复',
    },
    {
      key: 1001, //'clamp'
      label: '拉伸',
    },
    {
      key: 1002, // 'mirroredRepeat'
      label: '镜像重复',
    },
  ];

  return [
    {
      uiType: 'InputSlider',
      label: '旋转',
      fieldName: 'rotation',
      min: 0,
      max: 360,
    },
    {
      uiType: 'InputSlider',
      label: 'X轴缩放',
      fieldName: 'repeat.x',
      min: 1,
      max: 10,
    },
    {
      uiType: 'InputSlider',
      label: 'Y轴缩放',
      fieldName: 'repeat.y',
      min: 1,
      max: 10,
    },
    {
      uiType: 'InputSlider',
      label: 'X轴偏移',
      fieldName: 'offset.x',
      min: 0,
      max: 10,
      precisionOnSave: 4,
      precisionOnShow: 4,
    },
    {
      uiType: 'InputSlider',
      label: 'Y轴偏移',
      fieldName: 'offset.y',
      min: 0,
      max: 10,
      precisionOnSave: 4,
      precisionOnShow: 4,
    },
    {
      uiType: 'InputSlider',
      label: 'X轴速度',
      fieldName: 'offsetSpeed.x',
      min: -2,
      max: 2,
    },
    {
      uiType: 'InputSlider',
      label: 'Y轴速度',
      fieldName: 'offsetSpeed.y',
      min: -2,
      max: 2,
    },
    {
      uiType: 'Select',
      label: 'X轴环绕模式',
      fieldName: 'wrapS',
      options: wrapModeOptions,
    },
    {
      uiType: 'Select',
      label: 'Y轴环绕模式',
      fieldName: 'wrapT',
      options: wrapModeOptions,
    },
  ];
}
